import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "m-2 mt-4 mb-4 p-text-center" }
const _hoisted_5 = { class: "p-mt-2" }
const _hoisted_6 = { class: "table table-bordered table-hover" }
const _hoisted_7 = {
  class: "p-p-1",
  style: {"background-color":"#eee"},
  colspan: "6"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-minus-circle" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Deduct (Outstanding Check) ")
const _hoisted_10 = { style: {"float":"right"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"#004C97","color":"#fff"} }, [
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "DATE"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "PARTICULAR"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "TYPE"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "RECEIPT NO"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "NAME"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "AMOUNT")
], -1)
const _hoisted_12 = { class: "p-p-1" }
const _hoisted_13 = { class: "p-p-1" }
const _hoisted_14 = { class: "p-p-1" }
const _hoisted_15 = { class: "p-p-1" }
const _hoisted_16 = { class: "p-p-1" }
const _hoisted_17 = { class: "p-p-1" }
const _hoisted_18 = { style: {"background-color":"#6c757d","color":"#fff"} }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", {
  class: "p-p-1",
  colspan: "5"
}, null, -1)
const _hoisted_20 = { class: "p-p-1" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("TOTAL ")
const _hoisted_22 = { style: {"float":"right"} }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "p-p-1",
    style: {"background-color":"#eee"},
    colspan: "6"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus-circle" }),
    /*#__PURE__*/_createTextVNode(" ADD ")
  ])
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"#004C97","color":"#fff"} }, [
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "DATE"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "PARTICULAR"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "TYPE"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "RECEIPT NO"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "NAME"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "AMOUNT")
], -1)
const _hoisted_25 = { class: "p-p-1" }
const _hoisted_26 = { class: "p-p-1" }
const _hoisted_27 = { class: "p-p-1" }
const _hoisted_28 = { class: "p-p-1" }
const _hoisted_29 = { class: "p-p-1" }
const _hoisted_30 = { class: "p-p-1" }
const _hoisted_31 = { style: {"background-color":"#6c757d","color":"#fff"} }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", {
  class: "p-p-1",
  colspan: "5"
}, null, -1)
const _hoisted_33 = { class: "p-p-1" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("TOTAL ")
const _hoisted_35 = { style: {"float":"right"} }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "p-p-1",
    style: {"background-color":"#eee"},
    colspan: "6"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "pi pi-minus-circle" }),
    /*#__PURE__*/_createTextVNode(" DEDUCT ")
  ])
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"#004C97","color":"#fff"} }, [
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "DATE"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "PARTICULAR"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "TYPE"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "RECEIPT NO"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "NAME"),
  /*#__PURE__*/_createElementVNode("th", { class: "p-p-1" }, "AMOUNT")
], -1)
const _hoisted_38 = { class: "p-p-1" }
const _hoisted_39 = { class: "p-p-1" }
const _hoisted_40 = { class: "p-p-1" }
const _hoisted_41 = { class: "p-p-1" }
const _hoisted_42 = { class: "p-p-1" }
const _hoisted_43 = { class: "p-p-1" }
const _hoisted_44 = { style: {"background-color":"#6c757d","color":"#fff"} }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", {
  class: "p-p-1",
  colspan: "5"
}, null, -1)
const _hoisted_46 = { class: "p-p-1" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode("TOTAL ")
const _hoisted_48 = { style: {"float":"right"} }
const _hoisted_49 = { style: {"background-color":"#6c757d","color":"#fff"} }
const _hoisted_50 = {
  class: "p-p-1",
  colspan: "6"
}
const _hoisted_51 = { style: {"float":"left"} }
const _hoisted_52 = { style: {"float":"right"} }
const _hoisted_53 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search",
  style: {"font-size":"1.2rem"}
}, null, -1)
const _hoisted_55 = { class: "p-field" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Filter Month", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("h5", null, "OR", -1)
const _hoisted_58 = { class: "p-grid" }
const _hoisted_59 = { class: "p-col" }
const _hoisted_60 = { class: "p-field" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { for: "from" }, "Choose Month", -1)
const _hoisted_62 = { class: "p-grid" }
const _hoisted_63 = { class: "p-col" }
const _hoisted_64 = { class: "p-field" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Bank List", -1)
const _hoisted_66 = { class: "p-col" }
const _hoisted_67 = { class: "field" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Store Type", -1)
const _hoisted_69 = { class: "p-col-12" }
const _hoisted_70 = { class: "p-field" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { for: "filterStore" }, "Branch", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text p-p-1"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              icon: "pi pi-search",
              class: "p-button-success px-4",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              icon: "pi pi-print",
              class: "p-button-primary px-4",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printReceiptUtil()))
            })
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.storeName) + " Statement of Bank Reconcile", 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.searchFilters.bank.bank) + " " + _toDisplayString(_ctx.searchFilters.bank.branch) + " " + _toDisplayString(_ctx.searchFilters.bank.title) + " (" + _toDisplayString(_ctx.searchFilters.bank.number) + " )", 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.resultTitle), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _createElementVNode("h5", _hoisted_10, "Balance before " + _toDisplayString(_ctx.beforeStatement) + " : " + _toDisplayString(_ctx.formatAmount(_ctx.beforeStatementAmount)), 1)
            ])
          ]),
          _hoisted_11,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outStandingCheque, (i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.formatDate(i.receiptDate)), 1),
              _createElementVNode("td", _hoisted_13, _toDisplayString(i.accountHead), 1),
              _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.convertToFull(i.type)), 1),
              _createElementVNode("td", _hoisted_15, _toDisplayString(i.receiptNo), 1),
              _createElementVNode("td", _hoisted_16, _toDisplayString(i.profileName.profileName), 1),
              _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.formatAmount(i.amount)), 1)
            ]))
          }), 128)),
          _createElementVNode("tr", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("td", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.totalOutStanding)), 1)
            ])
          ]),
          _hoisted_23,
          _hoisted_24,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addTransactions, (i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.formatDate(i.receiptDate)), 1),
              _createElementVNode("td", _hoisted_26, _toDisplayString(i.accountHead), 1),
              _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.convertToFull(i.type)), 1),
              _createElementVNode("td", _hoisted_28, _toDisplayString(i.receiptNo), 1),
              _createElementVNode("td", _hoisted_29, _toDisplayString(i.profileName.profileName), 1),
              _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.formatAmount(i.amount)), 1)
            ]))
          }), 128)),
          _createElementVNode("tr", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("td", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.totalAddTransactions)), 1)
            ])
          ]),
          _hoisted_36,
          _hoisted_37,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deductTransactions, (i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.formatDate(i.receiptDate)), 1),
              _createElementVNode("td", _hoisted_39, _toDisplayString(i.accountHead), 1),
              _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.convertToFull(i.type)), 1),
              _createElementVNode("td", _hoisted_41, _toDisplayString(i.receiptNo), 1),
              _createElementVNode("td", _hoisted_42, _toDisplayString(i.profileName.profileName), 1),
              _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.formatAmount(i.amount)), 1)
            ]))
          }), 128)),
          _createElementVNode("tr", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("td", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.totalDeductTransactions)), 1)
            ])
          ]),
          _createElementVNode("tr", _hoisted_49, [
            _createElementVNode("td", _hoisted_50, [
              _createElementVNode("h5", null, [
                _createElementVNode("span", _hoisted_51, " Opening Balance : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.openingBalance)) + " (" + _toDisplayString(_ctx.formatDate(_ctx.openingBalanceDate)) + ") ", 1),
                _createElementVNode("span", _hoisted_52, " Balance till " + _toDisplayString(_ctx.endStatement) + " : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.totalBalanceAmount)), 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_Dialog, {
        visible: _ctx.productDialog,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.productDialog) = $event)),
        style: { width: '50vw' },
        maximizable: true,
        position: "top",
        class: "p-fluid"
      }, {
        header: _withCtx(() => [
          _createElementVNode("h5", _hoisted_53, [
            _hoisted_54,
            _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            type: "submit",
            label: "Search",
            icon: "pi pi-search",
            class: "p-button-primary",
            onClick: _ctx.loadList
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_55, [
            _hoisted_56,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.searchFilters.filterType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchFilters.filterType) = $event)),
              options: _ctx.dateFilters,
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearForFilters())),
              filter: true,
              optionLabel: "key",
              optionValue: "value"
            }, null, 8, ["modelValue", "options"])
          ]),
          _hoisted_57,
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  id: "from",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchFilters.date1) = $event)),
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args))),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.searchFilters.date1]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.searchFilters.bank,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchFilters.bank) = $event)),
                  options: _ctx.banksList,
                  placeholder: "Select a bank account"
                }, {
                  value: _withCtx((slotProps) => [
                    _createElementVNode("div", null, _toDisplayString(slotProps.value.bank) + " | " + _toDisplayString(slotProps.value.branch) + " | " + _toDisplayString(slotProps.value.number) + " | " + _toDisplayString(slotProps.value.title), 1)
                  ]),
                  option: _withCtx((slotProps) => [
                    _createElementVNode("div", null, _toDisplayString(slotProps.option.bank) + " | " + _toDisplayString(slotProps.option.branch) + " | " + _toDisplayString(slotProps.option.number) + " | " + _toDisplayString(slotProps.option.title), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _hoisted_68,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.searchFilters.storeType,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchFilters.storeType) = $event)),
                  options: _ctx.storeType,
                  filter: true,
                  optionLabel: "name",
                  optionValue: "value"
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _hoisted_71,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.searchFilters.storeID,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchFilters.storeID) = $event)),
                  options: _ctx.filterBranch,
                  filter: true,
                  optionLabel: "name",
                  optionValue: "id"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ]))
}